jQuery(document).ready(function ($) {
	gsap.registerPlugin(ScrollTrigger);

	// animate numbers
	function animateValue(id, start, end, duration) {
		// assumes integer values for start and end
		let obj = document.getElementById(id);
		let range = end - start;
		// no timer shorter than 50ms (not really visible any way)
		let minTimer = 50;
		// calc step time to show all interediate values
		let stepTime;
		if (Number.isInteger(end)) {
			stepTime = Math.abs(Math.floor(duration / range));
		} else {
			stepTime = (duration / range) * 0.1;
		}

		// never go below minTimer
		stepTime = Math.max(stepTime, minTimer);
		// get current time and calculate desired end time
		let startTime = new Date().getTime();
		let endTime = startTime + duration;
		let timer;
		let value = 0;

		function run() {
			let now = new Date().getTime();
			let remaining = Math.max((endTime - now) / duration, 0);

			if (Number.isInteger(end)) {
				value = Math.round(end - remaining * range);
			} else {
				value += 0.1;
			}

			if (value <= end && Number.isInteger(end)) {
				obj.innerHTML = value;
			} else if (
				parseFloat(value).toFixed(1) <= parseFloat(end).toFixed(1) &&
				!Number.isInteger(end)
			) {
				obj.innerHTML = value.toFixed(1);
			}

			if (value >= end) {
				clearInterval(timer);
			}
		}
		timer = setInterval(run, stepTime);
		run();
	}

	const singleNumbers = $(".number_wrapper .number").toArray();
	const otherNumbers = $("#numbers span.number").toArray();

	const numbers = $.merge(otherNumbers, singleNumbers);

	for (const num of numbers) {
		const id = $(num).attr("id");
		gsap.to(`#${id}`, {
			scrollTrigger: {
				start: "bottom bottom",
				trigger: `#${id}`,
				onEnter: () => {
					if ($(`#${id}`).text() < $(`#${id}`).data("target")) {
						animateValue(
							id,
							$(`#${id}`).text(),
							$(`#${id}`).data("target"),
							2000
						);
					}
				},
			},
		});
	}
});
